import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RouteRoles } from "ui/common/router/MainRouter.types";
import RoleRoute from "ui/user/containers/RoleRoute/RoleRoute";

const ProgramPage = lazy(() => import("ui/program/pages/ProgramPage"));
const ProgramsPage = lazy(() => import("ui/program/pages/ProgramsPage"));

export enum ProgramRoutes {
    MAIN = "/programs",
    PROGRAM = "/programs/:programAddress",
}

export const useProgramRoutes = (): RouteObject[] => {
    return [
        {
            path: ProgramRoutes.MAIN,
            element: (
                <RoleRoute roles={RouteRoles.PROGRAMS}>
                    <ProgramsPage />
                </RoleRoute>
            ),
        },
        {
            path: ProgramRoutes.PROGRAM,
            element: (
                <RoleRoute roles={RouteRoles.PROGRAMS}>
                    <ProgramPage />
                </RoleRoute>
            ),
        },
    ];
};
